var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUbicacion3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L16 0L16 16L0 16L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ubicacion-(3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L16 0L16 16L0 16L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3841 1.80894C11.2176 0.642438 9.6606 0 7.99991 0C6.3392 0 4.7822 0.642438 3.61566 1.80894C1.44504 3.97956 1.10523 6.58616 2.6057 9.55622C3.83641 11.9923 6.05285 14.2085 7.67126 15.8266L7.73476 15.8902C7.80801 15.9634 7.90395 16 7.99991 16C8.09588 16 8.19188 15.9634 8.26507 15.8902L8.3287 15.8265C9.94704 14.2084 12.1635 11.9922 13.3941 9.55612C14.8946 6.58609 14.5548 3.97956 12.3841 1.80894L12.3841 1.80894ZM12.7251 9.21807C11.5978 11.4496 9.56087 13.5324 8.00027 15.0947C6.43971 13.5325 4.40274 11.4495 3.27546 9.21817C1.91862 6.53232 2.20346 4.28226 4.14637 2.33939C5.2089 1.27689 6.60459 0.745605 8.00024 0.745605C9.39593 0.745605 10.7916 1.27686 11.8541 2.33939C13.797 4.28223 14.0819 6.53229 12.7251 9.21807L12.7251 9.21807ZM7.99892 3.80615C6.47995 3.80615 5.24414 5.04197 5.24414 6.56096C5.24414 8.07996 6.47995 9.31578 7.99892 9.31578C9.51792 9.31578 10.7537 8.07996 10.7537 6.56096C10.7537 5.04196 9.51795 3.80615 7.99892 3.80615L7.99892 3.80615ZM7.99892 8.56578C6.89348 8.56578 5.99414 7.66643 5.99414 6.56096C5.99414 5.4555 6.89348 4.55615 7.99892 4.55615C9.10439 4.55615 10.0037 5.4555 10.0037 6.56096C10.0037 7.66643 9.10439 8.56578 7.99892 8.56578L7.99892 8.56578Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbicacion3);
export default __webpack_public_path__ + "static/media/ubicacion3.7a62ffd512b070974e75d81364e07d44.svg";
export { ForwardRef as ReactComponent };